import React from "react";
import Block from "./Block";

import { BoxContainer } from "../styles";
import { helpers } from "../../../utils";

function Blocks(props) {
  const { summary } = props;

  const avgBalPerUser =
    summary?.uniqueActiveBalance / summary?.noOfUniqueActiveSavers
      ? Number(
          (
            summary?.uniqueActiveBalance / summary?.noOfUniqueActiveSavers
          ).toFixed(2)
        )
      : 0;
  const avgBalPerAccount =
    summary?.uniqueActiveBalance / summary?.noOfActiveSavings
      ? Number(
          (summary?.uniqueActiveBalance / summary?.noOfActiveSavings).toFixed(2)
        )
      : 0;

  return (
    <div>
      <BoxContainer>
        <Block value={summary.noOfSavings ?? 0} display="Savings" />
        <Block value={summary.noOfInvestments ?? 0} display="Investments" />
        <Block
          value={summary.noOfLoanApplications ?? 0}
          display="Loan Applications"
        />
      </BoxContainer>
      <BoxContainer>
        <Block
          value={summary.noOfActiveSavings ?? 0}
          display="Active Savings"
        />
        <Block
          value={summary.noOfPausedSavings ?? 0}
          display="Paused Savings"
        />
        <Block
          value={summary?.noOfUniqueActiveSavers ?? 0}
          display="Unique active savers"
        />
      </BoxContainer>
      <BoxContainer>
        <Block
          prefix="₦"
          duration={0}
          value={summary?.uniqueActiveBalance ?? 0}
          display="Active Savings Balance"
        />
        <Block
          prefix="₦"
          duration={0}
          value={avgBalPerUser}
          display="Average balance per user"
        />
        <Block
          prefix="₦"
          duration={0}
          value={avgBalPerAccount}
          display="Average balance per savings account"
        />
      </BoxContainer>
    </div>
  );
}

export default Blocks;
